
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as FAQSfWHr2UQ4oQTOC7dhCMOUyhQLliw3c9k6gTJX2YB5VAMeta } from "/app/pages/FAQ.vue?macro=true";
import { default as LabgWXszJ_45mRBtGIucBEGH_j8O5n1IiFwoMuOVI7zM4_45HgMeta } from "/app/pages/Lab.vue?macro=true";
import { default as teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta } from "/app/pages/team.vue?macro=true";
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as pressmzF5P4tliElByO1nSgeAhr7mMfuH48Lrbqc9BlsZOzMMeta } from "/app/pages/press.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as wipocN2CWcLXfovm4FZWAwD8jZ3pl7_y3DAyGfx0Zf_45_1kMeta } from "/app/pages/portal/wip.vue?macro=true";
import { default as indexj3LaXNzv4FCefdxuiK9AKfX6bD4_qM0_45zl7_FsdbByIMeta } from "/app/pages/portal/index.vue?macro=true";
import { default as spiffOXX_p1kWgl8y_45pn1H0vVjr4j3nUMQfCFMgydmCBHBsUMeta } from "/app/pages/portal/spiff.vue?macro=true";
import { default as capturerate48ZmJymLb_X2fIgRp8joy_XGLNnnbroePMr82UkDA8sMeta } from "/app/pages/portal/capturerate.vue?macro=true";
import { default as framecatalogL8JKnM5xZUGeES0HnMLRqpk8QkOGYYp8NVWu0mgF_NgMeta } from "/app/pages/portal/framecatalog.vue?macro=true";
import { default as spiffsummaryd6vMbmppMt2rcaXt7u4lKzzC4RZE_He6haeMR0IA0SIMeta } from "/app/pages/portal/spiffsummary.vue?macro=true";
import { default as Essilor_452019_45AwardsyqnGIP_45Dzhbc2_4Z6tgB4A1X5dzzC92_uStJzrhxcrUMeta } from "/app/pages/article/Essilor-2019-Awards.vue?macro=true";
import { default as AR_45Customer_45Conversations_45OnSight_45Optical1jaQpwr__45udrHzeZrRtBW1j2ttuF5_45yR47H96MVQzWcMeta } from "/app/pages/article/AR-Customer-Conversations-OnSight-Optical.vue?macro=true";
import { default as Technology_45Transformations_45OnSight_45OpticallqmC5Y5t_d3WsZTyaZ5cH8EYV_45UHa0KtblF6gGXjwZcMeta } from "/app/pages/article/Technology-Transformations-OnSight-Optical.vue?macro=true";
import { default as OnSight_45Optical_45Brings_45Dispensing_45Directly_45To_45MDsj3i6_45a8w6l6kQt_452mVyqf9ReleVawsYG2dkhIofKfM0Meta } from "/app/pages/article/OnSight-Optical-Brings-Dispensing-Directly-To-MDs.vue?macro=true";
export default [
  {
    name: "FAQ",
    path: "/FAQ",
    component: () => import("/app/pages/FAQ.vue")
  },
  {
    name: "Lab",
    path: "/Lab",
    component: () => import("/app/pages/Lab.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "press",
    path: "/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "portal-wip",
    path: "/portal/wip",
    meta: { ...(wipocN2CWcLXfovm4FZWAwD8jZ3pl7_y3DAyGfx0Zf_45_1kMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/wip.vue")
  },
  {
    name: "portal",
    path: "/portal",
    meta: { ...(indexj3LaXNzv4FCefdxuiK9AKfX6bD4_qM0_45zl7_FsdbByIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/index.vue")
  },
  {
    name: "portal-spiff",
    path: "/portal/spiff",
    meta: { ...(spiffOXX_p1kWgl8y_45pn1H0vVjr4j3nUMQfCFMgydmCBHBsUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/spiff.vue")
  },
  {
    name: "portal-capturerate",
    path: "/portal/capturerate",
    meta: { ...(capturerate48ZmJymLb_X2fIgRp8joy_XGLNnnbroePMr82UkDA8sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/capturerate.vue")
  },
  {
    name: "portal-framecatalog",
    path: "/portal/framecatalog",
    meta: { ...(framecatalogL8JKnM5xZUGeES0HnMLRqpk8QkOGYYp8NVWu0mgF_NgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/framecatalog.vue")
  },
  {
    name: "portal-spiffsummary",
    path: "/portal/spiffsummary",
    meta: { ...(spiffsummaryd6vMbmppMt2rcaXt7u4lKzzC4RZE_He6haeMR0IA0SIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/portal/spiffsummary.vue")
  },
  {
    name: "article-Essilor-2019-Awards",
    path: "/article/Essilor-2019-Awards",
    component: () => import("/app/pages/article/Essilor-2019-Awards.vue")
  },
  {
    name: "article-AR-Customer-Conversations-OnSight-Optical",
    path: "/article/AR-Customer-Conversations-OnSight-Optical",
    component: () => import("/app/pages/article/AR-Customer-Conversations-OnSight-Optical.vue")
  },
  {
    name: "article-Technology-Transformations-OnSight-Optical",
    path: "/article/Technology-Transformations-OnSight-Optical",
    component: () => import("/app/pages/article/Technology-Transformations-OnSight-Optical.vue")
  },
  {
    name: "article-OnSight-Optical-Brings-Dispensing-Directly-To-MDs",
    path: "/article/OnSight-Optical-Brings-Dispensing-Directly-To-MDs",
    component: () => import("/app/pages/article/OnSight-Optical-Brings-Dispensing-Directly-To-MDs.vue")
  }
]